import {
  laravelGet,
  laravelPost,
  laravelPut,
  laravelDelete,
  laravelRequest,
} from '../utils/laravelClient';
import { createQueryString } from '../utils/apiUtils';
import { apiCache } from '../utils/cache';

/** FE cache key for Hookah Flavors catalog (brands + nested flavours). */
export const HOOKAH_FLAVOURS_CACHE_KEY = 'all-brands';

/**
 * Full brands + flavours catalog (Hookah Flavors, BarTables, FlavorDetails).
 * Uses with_flavours=1 so Brands management stays on the light list endpoint.
 */
export const fetchAllBrands = async () =>
  laravelGet('/brands', { auth: 'admin', params: { with_flavours: 1 } });

/** Paginated brands-only list for Brands management. */
export const fetchBrands = async (params = {}) => {
  const qs = createQueryString(params);
  const path = qs ? `/brands?${qs}` : '/brands';
  return laravelRequest('GET', path, { auth: 'admin' });
};

export const getBrand = async (brandId) =>
  laravelGet(`/brands/${brandId}`, { auth: 'admin' });

export const createBrand = async (brandData) =>
  laravelPost('/brands', brandData, { auth: 'admin' });

export const updateBrand = async (brandId, brandData) =>
  laravelPut(`/brands/${brandId}`, brandData, { auth: 'admin' });

export const deleteBrand = async (brandId) =>
  laravelDelete(`/brands/${brandId}`, { auth: 'admin' });

/**
 * Bust FE cache and reload brands+flavours after flavour create / update / deactivate / reactivate.
 */
export const refreshHookahFlavoursCache = async () => {
  apiCache.invalidate(HOOKAH_FLAVOURS_CACHE_KEY);
  const response = await fetchAllBrands();
  const brands = Array.isArray(response) ? response : (response?.data ?? []);
  apiCache.set(HOOKAH_FLAVOURS_CACHE_KEY, brands);
  return brands;
};
